import React from 'react'
import PropTypes from 'prop-types'

import Icon from 'components/Icon'

import {
  IconContainer,
  IconText,
} from './styles'

const IconBlock = ({ icon, title }) => {
  return (
    <IconContainer>
      <Icon
        id={icon}
      />

      <IconText
        weight={'medium'}
        size={['16/20', '16/20', '16/20']}
        dangerouslySetInnerHTML={{ __html: title }}
      />
    </IconContainer>
  )
}

IconBlock.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}

export default IconBlock
